var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('input', _vm._g(_vm._b({
    class: _vm._f("twMerge")([_vm.inputVariants({
      variant: _vm.variant
    }), _vm.$attrs.class]),
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onChange
    }
  }, 'input', _vm.inputAttrs, false), _vm.inputListeners));
}
var staticRenderFns = []

export { render, staticRenderFns }